export default class CarouselItem extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   */
  constructor(scene, x, y, item, scale, itemScale) {
    super(scene, x, y, 'blank');
    this.name = item;
    scene.add.existing(this);
    //let spritePath = this.name === '' ? 'blank' : this.name + '.png';

    this.item = scene.add.sprite(x, y, 'blank');
    // this.setOrigin(0.5);
    this.initX = x;
    this.initY = y;
    this.itemDragging = false;
    this.charScale = scale;
    this.itemScale = itemScale;
    this.blocked = false;
    this.emitter = new Phaser.Events.EventEmitter();
    this.setDragEvents(scene);
  }

  min(a, b) {
    if (a < b) {
      return a;
    } else {
      return b;
    }
  }

  updateItem(itemName, freeplace, id, w, h) {
    this.itemID = id;
    //console.log(spritePath);
    this.freePlace = freeplace;
    let isFreePlace = this.freePlace === true;
    let atlasPath = isFreePlace ? 'freeplaceItems' : 'items';
    let spritePath = isFreePlace ? itemName + '.png' : 'c_' + itemName + '.png';
    this.item.setTexture(atlasPath, spritePath);
    // this.setOrigin(0.5, 0.5);
    let iconScale = isFreePlace ? 0.75 : 1;
    this.texWidth = this.item.width * this.charScale * this.itemScale;
    this.texHeight = this.item.height * this.charScale * this.itemScale;
    /*     let width = this.texWidth;
        let height = this.texHeight;
        let ratioX = w / width;
        let ratioY = h / height;
        let ratio = this.min(ratioX, ratioY) * 0.85; */
    this.iconWidth = this.item.width * iconScale;// * this.itemScale;
    this.iconHeight = this.item.height * iconScale;// * this.itemScale;
    //this.setDisplaySize(w, h);
    this.item.setDisplaySize(this.iconWidth, this.iconHeight);
    this.name = itemName;
  }

  update(time, delta) {
    if (this.itemDragging) {
      this.dragTime += delta;
    }
  }

  toggleInteractive(scene, toggleOn) {
    if (toggleOn) {
      this.setInteractive();
      scene.input.setDraggable(this);
      this.itemDragging = true;
      this.input.dragDistanceThreshold = 50;
      this.item.alpha = 1;
    } else {
      this.item.alpha = 0;
    }
  }

  setDragEvents(scene) {
    scene.input.on(
      'dragstart',
      function (pointer, gameObject) {
        if (gameObject === this && this.blocked === false) {
          this.forceReturn();
          this.itemDragging = true;
          this.sqrDragDist = 0;
          // this.setDisplaySize(this.texWidth, this.texHeight);
          this.item.setDisplaySize(this.texWidth, this.texHeight);
          //console.log('sprite scaling --> ' + this.charScale);
          //console.log('sprite width --> ' + this.texWidth);
        }
      },
      this
    );
    scene.input.on(
      'drag',
      function (pointer, gameObject, dragX, dragY) {
        if (gameObject === this) {
          if (pointer.isDown && this.blocked === false) {
            let x = this.x - dragX;
            let y = this.y - dragY;
            this.sqrDragDist += x * x + y * y;
            this.x = dragX;
            this.y = dragY;
            this.item.x = dragX;
            this.item.y = dragY;
          } else if (this.itemDragging === true) {
            this.dropItem();
          }
        }
      },
      this
    );

    scene.input.on(
      'dragend',
      function (pointer, gameObject) {
        if (gameObject === this) {
          this.dropItem();
        }
      },
      this
    );
  }


  returnToCarousel() {
    /*     if (tween == true) {
          this.returnTween = scene.tweens.add({
            targets: [this, this.item],
            x: this.initX,
            y: this.initY,
            duration: 250,
            ease: 'Quad.easeOut',
            onEnd: () => {
              //this.itemDragging = true;
            }
          });
        } else {
          this.forceReturn();
        } */
    this.itemDragging = false;
    this.forceReturn();
  }

  dropItem() {
    // gameObject.setDisplaySize(this.iconWidth, this.iconHeight);
    this.item.setDisplaySize(this.iconWidth, this.iconHeight);
    if (this.blocked === false) {
      this.emitter.emit(
        'touchUp',
        { x: this.x, y: this.y },
        this
      );
    }
  }

  forceReturn() {
    if (this.returnTween != null) {
      this.returnTween.stop();
      this.returnTween = null;
    }
    this.x = this.initX;
    this.y = this.initY;
    this.item.x = this.initX;
    this.item.y = this.initY;
  }

  destroy() {
    if (this.returnTween != null) {
      this.returnTween.stop();
      this.returnTween = null;
    }

    if (this.emitter != null) {
      this.emitter.destroy();
      this.emitter = null;
    }

    if (this.item != null) {
      this.item.destroy();
      this.item = null;
    }

    super.destroy();
  }
}
